import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_lp_count_by_project_warehouse_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { payload?: $frontendTypes.lp_count_by_project_warehouse_types[], action: string, skip?: number, take?: number, date_from?: string, date_to?: string, full_text_search?: string }): Promise<{ payload?: $frontendTypes.lp_count_by_project_warehouse_types[], success?: boolean, error?: any[], count?: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.action)) {
      $missingRequiredInParams.push('\'action\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

